import { RatedPower } from "../shared/rated-power";

export class PowerForecast {
  /* eslint-disable */
  name?: string;
  WTUR1_W_rated: number;
  rangeHours: number;
  WTUR1_MW_rated: number;
  dataSeries: any;
  weather: any;
  /* eslint-enable */

  static mapFromPortfolioMeteoBlue(portfolio, rangeHours) {
    const todayTs = new Date().setUTCHours(0, 0, 0, 0);
    const firstHour = new Date().getUTCHours() + 1;
    const startingTS = todayTs + firstHour * 60 * 60 * 1000;
    const theoData = JSON.parse(portfolio.DATA);

    return new PowerForecast({
      WTUR1_MW_rated: 210,
      dataSeries: {
        ratedPower: {
          data: new Array(rangeHours).fill(210)
        },
        theoPower: {
          data : theoData.filter((m, i) => i >= firstHour * 6 && i < firstHour * 6 + rangeHours * 6 && i % 6 === 0).slice(0, rangeHours).map(k => k * 1000),
          intervalTS: 1 * 60  * 60 * 1000,
          startingTS,
          lastTS: rangeHours * 60 * 60 * 1000 + startingTS
        }
      },
      rangeHours
    });
  }
  static mapFromParkMeteoBlue(park, rangeHours, code: string, weatherForecast: any) {
    const todayTs = new Date().setUTCHours(0, 0, 0, 0);
    const firstHour = new Date().getUTCHours() + 1;
    const startingTS = todayTs + firstHour * 60 * 60 * 1000;
    const theoData = JSON.parse(park.DATA);
    return new PowerForecast({
      WTUR1_MW_rated: code === 'EJO' ? 120  : (code === 'EON') ? 90 : 0,
      dataSeries: {
        ratedPower: {
          data: new Array(rangeHours).fill(210)
        },
        theoPower: {
          data : theoData.filter((m, i) => i >= firstHour * 6 && i < firstHour * 6 + rangeHours * 6 && i % 6 === 0).slice(0, rangeHours).map(k => k * 1000),
          intervalTS: 1 * 60  * 60 * 1000,
          startingTS,
          lastTS: rangeHours * 60 * 60 * 1000 + startingTS
        }
      },
      rangeHours,
      weather: this.getHourlyMeteoBlueWeather(weatherForecast, rangeHours, startingTS)
    });
  }
  static mapFromPortfolio(portfolio: any, rangeHours) {
    return new PowerForecast({
      WTUR1_MW_rated: portfolio.dataDebbug.WTUR1_MW_rated.sum,
      dataSeries: this.generateData(portfolio, portfolio.dataDebbug.WTUR1_MW_rated.sum),
      rangeHours
    });
  }



  static mapFromPark(park: any, rangeHours) {
    let weather =  park.forecastDataSeries.theoPower.length > 1 ? null : park.forecastDataSeries.windSpd[0].data;
    if (weather) {
      weather = weather.map((e, i) => {
        return {
          wind_speed : e,
          wind_direction : park.forecastDataSeries.windDir[0].data[i],
          temperature : park.forecastDataSeries.temp[0].data[i],
          timestamp: park.forecastDataSeries.windSpd[0].startingTS + park.forecastDataSeries.windSpd[0].intervalTS * i
        };
      });
      if (rangeHours === 120) {
        weather = weather.filter((e, i) => new Date(e.timestamp).getHours() % 12 === 0  );
      } else {
        weather = weather.filter((e, i, arr) => new Date(e.timestamp).getHours() % 3 === 0 || i === 0 || i  === arr.length - 1);

      }
    }
    return new PowerForecast({
      WTUR1_MW_rated: park.dataDebbug.WTUR1_MW_rated.sum,
      dataSeries: this.generateData(park, park.dataDebbug.WTUR1_MW_rated.sum),
      rangeHours,
      // weather: this.getHourlyWeather(park.dataSeries, rangeHours)
      weather

    });
  }

  static mapFromIconsPark(data: any, rangeHours: number, arrLength: any) {
    let icons = data[0]?.data?.map((e, i) => {
      return {
        icon : e,
        timestamp : data[0].startingTS + data[0].intervalTS * i
      };
    });
    if (rangeHours === 120) {
      icons = icons?.filter((e, i) => new Date(e.timestamp).getHours() % 12 === 0 );
      while (icons?.length < arrLength) {
        icons.push(icons[icons.length - 1]);
      }
    } else {
      icons = icons?.filter((e, i, arr) => new Date(e.timestamp).getHours() % 3 === 0 || i === 0 || i === arr.length - 1 );
    }
    return icons;
  }

  static getHourlyMeteoBlueWeather(dt: any, rangeHours: number, startTs: number) {
    const range = rangeHours !== 120 ? rangeHours / (rangeHours / 1) : 4;
    const ind = (Math.ceil(new Date().getTime() / (3600000 * range)) * (3600000 * range) - startTs) / 3600000;
    const data = dt.reduce((filtered, next, i) => {
      const obj: any = {};
      if (next.UNIXTS >= startTs  && next.UNIXTS < startTs + rangeHours * 60 * 60 * 1000 &&
        (i + ind) % range === 0) {
          // obj.icon = next.ICON,
          obj.wind_speed = next.WIND_SPEED;
          obj.wind_direction = next.DEG_WIND;
          obj.temperature = next.AMB_TEMP;
          obj.timestamp = dt.UNIXTS;
          filtered.push(obj);
        }
      return filtered;
    }, []);
    return data;
  }
  static getHourlyWeather(dt: any, rangeHours: number) {
    const range = rangeHours !== 120 ? rangeHours / (rangeHours / 1) : 4;
    const ind = (Math.ceil(new Date().getTime() / (3600000 * range)) * (3600000 * range) - dt.windSpd.startingTS) / 3600000;
    const data = dt.windSpd.data.reduce((filtered, next, i) => {
      const obj: any = {};
      if ((i + ind) % range === 0) {
        obj.icon = dt.icon.data[i];
        obj.wind_speed = next;
        obj.wind_direction = dt.windDir.data[i];
        obj.temperature = dt.temp.data[i];
        obj.timestamp = dt.icon.startingTS + (dt.icon.intervalTS * i);
        filtered.push(obj);
      }
      return filtered;
    }, []);
    return data;
  }

  static generateData(dataSeries: any, ratedPower: number): any {
    if (dataSeries) {
      dataSeries.forecastDataSeries.ratedPower = {
        data: dataSeries.forecastDataSeries.theoPower[0].data
        ? this.generateRatedPower(dataSeries, ratedPower)
        : []
      };
      return dataSeries.forecastDataSeries;
    }
  }

  static generateRatedPower(data, ratedPower) {
    return RatedPower.generate(ratedPower, data.forecastDataSeries.theoPower[0].data.length);
  }
	
  constructor(init: Partial<PowerForecast>) {
    Object.assign(this, init);
  }

}
